module.exports = __webpack_public_path__ + "media/src/img/worktime-icon-8d2c2c780808f030b86150b056b4051f.svg";